<template>
  <div class="f-col modal-background" @click.self="closeModal">
    <div class="f-col modal" @click.stop>
      <portal-target name="modal" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    closeModal() {
      this.$store.commit("TOGGLE_DISPLAY_MODAL", {
        display: false,
        target: "",
      });
    },
  },
};
</script>

<style scoped>
.modal-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  align-items: center;
  justify-content: flex-start;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal {
  max-width: 86vw;
  padding: 15px;
  margin: 15px auto;
  border-radius: 0.4rem;
  background-color: #ffffff;
  box-shadow: 1px 1px 32px rgba(0, 0, 0, 0.2);
}
</style>